module.exports = "<button (click)=\"openNavMenu()\" class=\"nav-menu-button\">\r\n    <i class=\"fas fa-cog\"></i>\r\n</button>";